RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    // The view that will be rendered for this widget. See App.widgets.Chart
    // for more info
    const MetricXY = App.widgets.Chart.extend({
        chartType: RivalIQ.graph.XY,

        // Called when `render` is called. This is the chance to load data
        // needed for the view.  A good practice is to load every time and rely
        // on the cache layer to sort out if we actually need to go to the
        // server
        loadData: function () {
            const me = this;

            // Construct a model for fetching metric data. Hopefully this will
            // go away w/ the universal metric api
            const metrics = new RivalIQ.collections.MetricDefinitions(me.dashboardModel.metrics);

            // Return a deferred to track this async operation.
            // While the deferred is pending the view will show a loading state
            // If the deferred fails the view will show an error view
            // If it succeeds it calls onRenderLoaded
            return metrics.fetch().done(function (metrics) {
                me.collection = metrics;
            });
        },

        // This is called by the parent class. Turns our loaded metrics into
        // a data format consumable by RivalIQ.graph.XY
        getChartAttributes: function () {
            const me = this;

            const primaryMetric = me.collection.at(0);
            const secondaryMetric = me.collection.at(1);
            const metricData = me.collection.invoke('getChartData');
            const focusCompanyId = me.getProp('focusCompanyId');

            me.collection.at(1).getValue();

            const data = _.reduce(_.head(metricData), function (memo, primaryData, i) {
                const x = _.last(primaryData);
                const y = _.last(metricData[1][i]);

                if (_.isFinite(x) && _.isFinite(y)) {
                    memo.push({
                        x: x,
                        y: y,
                        id: _.head(primaryData),
                        label: primaryMetric.getDimension(primaryData, 'companyId'),
                        focus: primaryData[0] === focusCompanyId
                    });
                }

                return memo;
            }, []);

            const nameOptions = {
                dimensions: me.getProp('nameDimensions')
            };

            function formatX(value) {
                return primaryMetric.format(value);
            }

            function formatY(value) {
                return secondaryMetric.format(value);
            }

            return {
                data: data,
                formatX: formatX,
                formatY: formatY,
                height: RivalIQ.enums.chart.CHART_HEIGHT,
                width: me.getProp('width'),
                xlabel: primaryMetric.getName(nameOptions),
                ylabel: secondaryMetric.getName(nameOptions)
            };
        }
    });

    // This is a widget definition for the xy chart. It is initialized from the
    // data provided in a widget configuration. To see how we define these for
    // favorites visit apps.Favorites.data.chartTypes

    // Inherits from ChartWidget which provides default custom chart
    // functionality like custom titles, a panel w/ edit button, account and
    // token restrictions, etc
    const MetricXyChartWidget = widgets.ChartWidget.extend({
        // The view that will be rendered for this widget
        view: MetricXY,

        hasFooter: _.constant(true),
        footerView: App.views.WarningLegendFooterView,

        // The title that will appear in the panel
        getChartTitle: function () {
            const me = this;
            const dimensions = ['channel', 'timeAnalysisMode'];

            return [
                // These static methods take a plain object metric definition
                // Dimensions is an array of extra dimension values that should
                // be added to the title
                RivalIQ.metric.names.metricName(me.metrics[0], {
                    dimensions: dimensions
                }),
                RivalIQ.metric.names.metricName(me.metrics[1], {
                    dimensions: dimensions
                })
            ].join(' vs. ');
        },

        // Returns a boolean indicating if the provided props are valid for
        // this widget. Used to enable/disable widgets in the favorites builder
        isSupported: function (props) {
            if (!props.metrics || props.metrics.length !== 2) {
                return false;
            }

            if (!_.every(props.metrics, RivalIQ.metric.property.isNumeric)) {
                return false;
            }

            return true;
        },

        // Called on initialization and every time setProps is called.
        // This is where we set default props or calculate values based on
        // props
        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                nameDimensions: ['channel', 'timeAnalysisMode'],
                useUniversalMetricsApi: me.curation.isCustomDashboard
            });

            // build a metrics array from props.metrics that inherits from this
            // widget's props
            // Important - we dont override props.metrics here to avoid looping
            me.metrics = me.buildMetrics(props);

            // The returned value is set on me.attributes. These values always
            // get precedence when calling `getProps`
            return props;
        }
    });

    // Maps the widget model to an enum we can use to refer to it from
    // a serialized configuration
    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_XY_CHART, MetricXyChartWidget);
});
